import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userId: null,
  adminType: "",
  userEmail: "",
  clubName: "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserId(state, action) {
      state.userId = action.payload;
    },
    clearUserId(state) {
      state.userId = null;
    },
    setAdminType(state, action) {
      state.adminType = action.payload;
    },
    clearAdminType(state) {
      state.adminType = null;
    },
    setUserEmail(state, action) {
      state.userEmail = action.payload;
    },
    clearUserEmail(state) {
      state.userEmail = null;
    },
    setClubName(state, action) {
      state.clubName = action.payload;
    },
    clearClubName(state) {
      state.clubName = null;
    },
  },
});

export const {
  setUserId,
  clearUserId,
  setAdminType,
  clearAdminType,
  setUserEmail,
  clearUserEmail,
  setClubName,
  clearClubName,
} = userSlice.actions;
export default userSlice.reducer;
